<div class="d-flex flex-column h-100 content">
  <div #header class="header">
    <!-- Bande de couleur en haut du header -->
    <div class="color-band">
      <span class="bleu-vert"></span>
      <span class="vert-clair"></span>
      <span class="orange"></span>
      <span class="rose"></span>
      <span class="bleu-vert responsive-none"></span>
      <span class="vert-clair responsive-none"></span>
      <span class="orange responsive-none"></span>
      <span class="rose responsive-none"></span>
    </div>

    <div class="col-md-12 d-flex container-header">

      <!-- ------------------------------------- -->

      <div id="top-header">
        <span class="bleu"></span>
        <span class="jaune"></span>
        <span class="orange"></span>
        <span class="violet"></span>
        <span class="bleu"></span>
        <span class="jaune"></span>
        <span class="orange"></span>
        <span class="violet"></span>
      </div>

      <!-- DEBUT HEADER -->
      <header #header id="header" >
        <div id="logo" #logo class="panel-pane pane-page-logo col-md-1">
          <div class="pane-content">
            <a href="https://www.gustaveroussy.fr/" routerLinkActive="active">
              <img typeof="foaf:Image" src="assets/logo-header.jpg" width="336" height="213" alt="Gustave Roussy"
                class="logo">
            </a>
          </div>
        </div>

        <div #contentHeader class="content-header col-md-11">
          <div #top class="top d-flex">
            <div class="top-left col-md-8 d-none">
              <div #paneContent class="pane-content">
                <ng-container *ngFor="let menuItem of HeaderMenuListTop">

                  <ng-container *ngIf="!menuItem.children">
                    <a class="nav-link">
                      <span class="icon fa" [ngClass]="menuItem.icon"></span>
                      <span class="text-holder">{{menuItem.label}}</span>
                    </a>
                  </ng-container>
                  <ng-container *ngIf="menuItem.children.length > 0">
                    <a #button mat-button href="https://www.gustaveroussy.fr/fr/informations-pratiques"
                      [matMenuTriggerFor]="levelOne" #levelOneTrigger="matMenuTrigger"
                      (mouseenter)="buttonEnter(levelOneTrigger,'menu1')" (mouseleave)="buttonLeave(levelOneTrigger)"
                      >
                      <!-- <span class="icon fa" [ngClass]="menuItem.icon"></span> -->
                      <span>{{menuItem.label}}
                        <!-- <i class="fa fa-chevron-down"></i> -->
                      </span>
                    </a>

                    <mat-menu #levelOne="matMenu" direction="down" yPosition="below" class="first-level-menu" >
                      <span class="pcv" (mouseenter)="menuEnter()" (mouseleave)="menuLeave(levelOneTrigger)">
                        <ng-container *ngFor="let childL1 of menuItem.children">
                          <li class="p-0" *ngIf="!childL1.children" mat-menu-item>
                            <a class="nav-link">{{childL1.label}}
                              <i *ngIf="childL1.icon" [ngClass]="childL1.icon"></i>
                            </a>
                          </li>
                          <ng-container *ngIf="childL1.children && childL1.children.length > 0">
                            <li (mouseenter)="buttonEnterLI(levelTwoTrigger,levelOneTrigger)" mat-menu-item #levelTwoTrigger="matMenuTrigger" [matMenuTriggerFor]="levelTwo">
                              <span class="icon fa" [ngClass]="childL1.icon"></span>
                              <span>{{childL1.label}}</span>
                            </li>

                            <mat-menu #levelTwo="matMenu" direction="down" yPosition="below" class="seccond-level-menu">
                              <span (mouseenter)="menu2enter()"
                                (mouseleave)="menu2Leave(levelOneTrigger,levelTwoTrigger)">
                                <ng-container *ngFor="let childL2 of childL1.children">
                                  <li class="p-0" mat-menu-item>
                                    <a class="nav-link">{{childL2.label}}
                                      <i *ngIf="childL2.icon" [ngClass]="childL2.icon"></i>
                                    </a>
                                  </li>
                                </ng-container>
                              </span>
                            </mat-menu>
                          </ng-container>
                        </ng-container>
                      </span>
                    </mat-menu>
                  </ng-container>
                </ng-container>
                <a class="linkrdv" href="https://rdv.gustaveroussy.fr/">Prendre rendez-vous</a>
              </div>

            </div>

            <div class="top-right col-md-4">
              <div class="float-right d-none">
                <div class="pane-content">
                  <a href="https://soutenir.gustaveroussy.fr/revolution-therapeutique?reserved_media=WEBHEADER"
                    class="btn-jfud" id="gustavelogoid">JE FAIS UN DON</a>
                </div>
              </div>
              <div class="float-right">
                <div class="d-flex justify-content-end pane-content">
                  <button clbuttonss="deco-text" class="bouton-langue font-size-responsive" (click)="changeLangue()"
                    *ngIf="displayLangue === true">{{langue}}</button>
                </div>
              </div>

              <div class="link-espace float-right d-none">
                <a href="/fr/content/accès-réservé" id="gustavelogoid">
                  <mat-icon (click)="tooltipPassport.show()" #tooltipPassport="matTooltip"
                    matTooltip="{{texteService.getTexte('TOOLTIP_ESPACE_RESERVE')}}"></mat-icon>
                </a>
              </div>
              <div class="float-right" id="search-box d-none">
                <a href="https://www.gustaveroussy.fr/fr/search/node">
                </a>
              </div>

            </div>
          </div>

          <div class="bottom d-none">
            <div class="pane-content">
              <ng-container *ngFor="let menuItem of HeaderMenuListBottom">
                <ng-container *ngIf="menuItem.children.length > 0">
                  <a #button mat-button href="https://rdv.gustaveroussy.fr/fr/content/hp-la-recherche"
                    [matMenuTriggerFor]="levelOne" #levelOneTrigger="matMenuTrigger"
                    class="{{menuItem.class}}" (mouseenter)="buttonEnter(levelOneTrigger,'menu2')"
                    (mouseleave)="buttonLeave(levelOneTrigger)" >
                    <!-- <span class="icon fa" [ngClass]="menuItem.icon"></span> -->
                    <span class="lable-name">{{menuItem.label}}</span>
                  </a>
                  <mat-menu #levelOne="matMenu" direction="down" yPosition="below" class="first-level-menu">
                    <span (mouseenter)="menuEnter()" (mouseleave)="menuLeave(levelOneTrigger)">
                      <ng-container *ngFor="let childL1 of menuItem.children">
                        <li class="p-0" *ngIf="!childL1.children" mat-menu-item>
                          <a class="nav-link">{{childL1.label}}
                            <i *ngIf="childL1.icon" [ngClass]="childL1.icon"></i>
                          </a>
                        </li>
                        <ng-container *ngIf="childL1.children && childL1.children.length > 0">
                          <li (mouseenter)="buttonEnterLI(levelTwoTrigger,levelOneTrigger)" mat-menu-item #levelTwoTrigger="matMenuTrigger" [matMenuTriggerFor]="levelTwo">
                            <span class="icon fa" [ngClass]="childL1.icon"></span>
                            <span>{{childL1.label}}</span>
                          </li>

                          <mat-menu #levelTwo="matMenu" direction="down" yPosition="below" class="seccond-level-menu">
                            <span (mouseenter)="menu2enter()"
                              (mouseleave)="menu2Leave(levelOneTrigger,levelTwoTrigger)">
                              <ng-container *ngFor="let childL2 of childL1.children">
                                <li class="p-0" mat-menu-item>
                                  <a class="nav-link">{{childL2.label}}
                                    <i *ngIf="childL2.icon" [ngClass]="childL2.icon"></i>
                                  </a>
                                </li>
                              </ng-container>
                            </span>
                          </mat-menu>
                        </ng-container>
                      </ng-container>
                    </span>
                  </mat-menu>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </header>
      <!-- FIN HEADER -->

      <!-- --------------------------------------- -->
    </div>
  </div>
  <router-outlet>
  </router-outlet>
  <div class="footer">
    <div class="container-footer col-md-8">
      <div class="copyright-margin-top d-flex flex-row">
        <button type="button" (click)="goToMentions()" class="uppercase copyright deco-text">
          {{this.texteService.getTexte('LABEL_GO_MENTIONS')}}</button> <br>
        <button type="button" (click)="goToProtection()" class="uppercase copyright deco-text">
          {{this.texteService.getTexte('LABEL_GO_DONNEES_PERSO')}}</button>
      </div>
      <div class="social footer col-md-4 d-none">
        <div class="panel-pane pane-menu-tree pane-menu-social-links">
          <div class="pane-content">
            <div
              class="menu-block-wrapper menu-block-ctools-menu-social-links-1 menu-name-menu-social-links parent-mlid-0 menu-level-1">
              <ul class="menu">
                <li class="first leaf menu-mlid-28697 newsletter"><a
                    href="https://www.gustaveroussy.fr/fr/newsletter-gustave-roussy" class="newsletter">Newsletter</a>
                </li>
                <li class="leaf menu-mlid-28696 instagram"><a href="https://www.instagram.com/gustave_roussy"
                    class="instagram" target="_blank">instagram</a></li>
                <li class="leaf menu-mlid-28695 youtube"><a href="https://www.youtube.com/@GustaveRoussyVideo"
                    class="youtube" target="_blank">youtube</a></li>
                <li class="leaf menu-mlid-28694 linkedin"><a href="https://www.linkedin.com/company/39072"
                    class="linkedin" target="_blank">linkedin</a></li>
                <li class="leaf menu-mlid-2990 twitter"><a href="https://twitter.com/GustaveRoussy"
                    target="_blank">twitter</a></li>
                <li class="last leaf menu-mlid-2989 facebook"><a href="https://www.facebook.com/gustave.roussy"
                    class="facebook" target="_blank">facebook</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
